export default function BrokenCremone() {
  const checks = [
    "Ne forcez jamais la poignée : vous risquez de casser la tige de la crémone",
    "Ne tentez pas d'ouvrir avec un tournevis : vous endommageriez le dormant",
    "Notez la marque de la fenêtre (souvent gravée sur le profilé) pour le diagnostic",
    "Prenez une photo du mécanisme par l'entrebâilleur si la fenêtre est légèrement ouverte",
    "Appelez DF PRO : nous débloquons et remplaçons la crémone sans dégrader la menuiserie",
  ];

  return (
    <section className="bg-rose-50 py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-[1280px] mx-auto">
          <p className="font-serif italic text-plum-dark text-sm md:text-base mb-3">
            Urgence et conseils
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-plum mb-8 leading-tight">
            Crémone cassée, <span className="font-serif italic">fenêtre fermée</span> : que faire
          </h2>

          <div className="space-y-6 text-plum-dark text-base md:text-lg leading-relaxed mb-10">
            <p>
              C'est la panne la plus stressante : la crémone casse alors que la fenêtre est fermée et verrouillée. Vous tournez la poignée, mais le mécanisme ne répond plus. La fenêtre reste bloquée, impossible à ouvrir pour aérer ou pour qu'un technicien accède au dormant. Ne paniquez pas et surtout ne forcez pas : une poignée bloquée peut cacher une tige déjà fendue, et forcer la manœuvre aggrave la casse ou déforme le dormant.
            </p>
            <p>
              Notre technicien arrive avec un kit complet pour débloquer la fenêtre sans la dégrader. Selon la configuration, nous accédons au mécanisme par le profilé, déverrouillons manuellement les points de fermeture, puis remplaçons la crémone usée par une neuve compatible. L'intervention prend généralement entre 45 minutes et 1h30. Vous repartez avec une fenêtre fluide, sécurisée et parfaitement étanche.
            </p>
          </div>

          <div className="bg-white rounded-2xl border border-rose-200 p-6 md:p-8">
            <h3 className="font-semibold text-plum text-base md:text-lg mb-5">
              Ce qu'il faut faire (et ne pas faire) en attendant le technicien
            </h3>
            <ul className="space-y-3">
              {checks.map((item, i) => (
                <li key={i} className="flex items-start gap-3">
                  <div className="w-6 h-6 rounded-full bg-coral/10 flex items-center justify-center shrink-0 mt-0.5">
                    <i className="ri-check-line text-coral text-sm" />
                  </div>
                  <span className="text-sm md:text-base text-plum-dark">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}